const styles = theme => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        paddingTop: theme.boxPadding ? theme.spacing(theme.boxPadding / 2 / 2.5) : null,
        paddingBottom: theme.boxPadding ? theme.spacing(theme.boxPadding / 2 / 1.5) : null,
        paddingLeft: theme.boxPadding ? theme.spacing(theme.boxPadding / 2) : null,
        paddingRight: theme.boxPadding ? theme.spacing(theme.boxPadding / 2) : null,
        ...(!theme.isMobile && {
            paddingTop: theme.boxPadding ? theme.spacing(theme.boxPadding / 1.5) : null,
            paddingBottom: theme.boxPadding ? theme.spacing(theme.boxPadding / 1.5) : null,
            paddingLeft: theme.boxPadding ? theme.spacing(theme.boxPadding) : null,
            paddingRight: theme.boxPadding ? theme.spacing(theme.boxPadding) : null
        })
    },
    formControl: {
        margin: theme.spacing(0)
    },
    group: {
        margin: `${theme.spacing(1)}px 0`
    },
    headerImageWrapper: {
        margin: -theme.spacing(1) * 2,
        marginBottom: theme.spacing(0),
        borderTopLeftRadius: theme.borderRadius ? theme.borderRadius + 'px!important' : '20px!important',
        borderTopRightRadius: theme.borderRadius ? theme.borderRadius + 'px!important' : '20px!important',
        overflow: 'hidden',
        ...(!theme.isMobile && {
            margin: -theme.spacing(1) * 4,
            marginTop: -theme.spacing(1) * 2,
            marginBottom: theme.spacing(1)
        })
    },
    headerImage: {
        maxWidth: '100%'
    },
    buttons: {
        marginTop: theme.spacing(2),
        marginBottom: 0,
        paddingBottom: '0!important',
        ...(theme.isMobile && {
            padding: '4px!important'
        })
    },
    button: {
        width: '100%',
        fontWeight: 500,
        marginRight: theme.spacing(1.5),
        marginBottom: theme.spacing(1),
        color: '#fff!important',
        boxShadow: theme.button ? theme.button.boxShadow : null,
        borderRadius: theme.forwardButton ? theme.forwardButton.borderRadius : 32,
        textTransform: theme.forwardButton ? theme.forwardButton.textTransform : null,
        ...(theme.isMobile && {
            padding: '8px 24px!important'
        })
    },
    rightIcon: {
        marginLeft: theme.spacing(1),
        marginTop: theme.spacing(0.75),
        marginBottom: theme.spacing(0.75),
        marginRight: -theme.spacing(1) * 0.5
    },
    radio: {
        minWidth: '110px'
    },
    selectButton: {
        marginTop: theme.spacing(1.7),
        marginRight: theme.spacing(2),
        minWidth: '112px'
    },
    logoImg: {
        filter: 'grayscale(100%)',
        opacity: 0.5
    },
    questionWrapper: {
        marginBottom: theme.spacing(2)
    },
    imageWrapper: {
        width: '100%',
        textAlign: 'center',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    image: {
        maxWidth: '100%',
        height: 'auto'
    },
    dialog: {
        margin: '0 -24px!important'
    },
    questionContainer: {
        width: 'calc(100% + 16px)',
        margin: '-8px',
        ...(theme.isMobile && {
            width: 'calc(100% + 8px)',
            margin: '-4px'
        })
    },
    footerProgressBar: {
        marginTop: 33,
        borderRadius: 0,
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4,
        height: '9px !important',
        boxShadow: '0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12);'
    }
})

export {styles}
